import React, { useState } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'

const SubscribeForm = ({ placeholder, cta }) => {
  const [email, setEmail] = useState('')
  const [isSubscribed, setIsSubscribed] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)

  return (
    <form
      method="post"
      target="_top"
      action-xhr="https://sipreads.com/api/subscribe"
      className="w-full"
      onSubmit={async (e) => {
        e.preventDefault()
        setIsSubmitted(true)
        const response = await axios.post(
          'https://sipreads.com/api/subscribe',
          { email },
          { headers: { 'Content-Type': 'application/json' } },
        )
        setIsSubmitted(false)
        setIsSubscribed(true)
        console.log(response)
      }}
    >
      <div className="flex flex-col items-center w-full">
        <div className="flex items-center w-full vertical">
          <input
            type="email"
            name="email"
            placeholder={placeholder}
            className="w-full h-16 text-lg text-center transition-all transition duration-200 ease-in-out bg-gray-100 border-2 border-b-0 border-gray-800 rounded rounded-b-none md:h-20 md:text-xl focus:outline-none focus:bg-white hover:bg-white"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <input
          className="w-full h-16 px-3 py-2 text-lg font-medium text-white transition-all transition duration-200 ease-in-out bg-gray-800 border-2 border-t-0 border-gray-800 rounded rounded-t-none cursor-pointer md:h-20 md:text-xl hover:bg-gray-700 hover:border-gray-700"
          type="submit"
          value={isSubmitted ? `Subscribing...` : cta}
        />
      </div>
      {isSubscribed && (
        <div className="p-4 mt-2 text-lg text-white bg-green-500 rounded">
          Awesome! You are now subscribed!
        </div>
      )}
      <div submit-success>
        <template type="amp-mustache">
          <div className="absolute p-4 mt-2 text-lg text-white bg-green-500 rounded">
            Awesome! You are now subscribed!
          </div>
        </template>
      </div>
      <div submit-error>
        <template type="amp-mustache">Error.</template>
      </div>
    </form>
  )
}

SubscribeForm.propTypes = {
  placeholder: PropTypes.string.isRequired,
  cta: PropTypes.string.isRequired,
}

export default SubscribeForm
